<template>
  <div class="version1-left-top">
    <Header title="专利转化价值分布"></Header>
    <div class="ecahrtBlock" ref="echarts"></div>
  </div>
</template>

<script>
import Header from './header.vue'
import { getValueRange, getWorthRange, isClassify } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
import 'echarts-gl'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      rangeList: [],
      rangeMap: {
        核心专利: 1,
        重要专利: 2,
        一般专利: 3,
        潜力专利: 4,
        沉默专利: 5
      },
      noClassify: {
        核心专利: '价值度区间=("10" or "9")',
        重要专利: '价值度区间=("8" or "7")',
        一般专利: '价值度区间=("4" or "3")',
        潜力专利: '价值度区间=("6" or "5")',
        沉默专利: '价值度区间=("2" or "1")'
      },
      max: 0
    }
  },
  components: {
    Header
  },
  async mounted() {
    await this.getPatent()
    this.valueRange()
  },
  methods: {
    async getPatent() {
      const res = await getWorthRange()
      if (res.code === 200) {
        const worthRange = res.data
        this.rangeMap = {}
        if (worthRange && worthRange.length > 0) {
          worthRange.forEach(item => {
            this.rangeMap[item.levelName] = item.levelNo
          })
        }
      }
    },
    valueRange() {
      getValueRange().then(res => {
        if (res[this.codeMapping]) {
          this.rangeList = res[this.dataMapping]
          this.max = this.rangeList.reduce((prev, current) => (prev.count > current.count ? prev : current)).count
          this.init()
        }
      })
    },
    init() {
      const myChart = this.$echarts.init(this.$refs.echarts)
      // 图表点击事件
      myChart.on('click', async params => {
        const name = params.name || params.seriesName
        if (name) {
          const res = await isClassify()
          let expression = ''
          if (res.data) {
            expression = 'worth_level_stat=' + this.rangeMap[name]
            this.jumpIpi(`${expression} and 专利状态=有效`)
          } else {
            expression = this.noClassify[name]
            this.jumpIpi(`${expression}`, 'isMerge', 'publicOrder')
          }
          // this.jumpIpi(`${expression} and 专利状态=有效`)
        }
      })
      // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
      function getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, height) {
        // 计算
        const midRatio = (startRatio + endRatio) / 2

        const startRadian = startRatio * Math.PI * 2
        const endRadian = endRatio * Math.PI * 2
        const midRadian = midRatio * Math.PI * 2

        // 如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
          isSelected = false
        }

        // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
        k = typeof k !== 'undefined' ? k : 1 / 3

        // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
        const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
        const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0

        // 计算高亮效果的放大比例（未高亮，则比例为 1）
        const hoverRate = isHovered ? 1.05 : 1

        // 返回曲面参数方程
        return {

          u: {
            min: -Math.PI,
            max: Math.PI * 3,
            step: Math.PI / 32
          },

          v: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },

          x: function (u, v) {
            if (u < startRadian) {
              return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            if (u > endRadian) {
              return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
          },

          y: function (u, v) {
            if (u < startRadian) {
              return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            if (u > endRadian) {
              return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
          },

          z: function (u, v) {
            if (u < -Math.PI * 0.5) {
              return Math.sin(u)
            }
            if (u > Math.PI * 2.5) {
              return Math.sin(u)
            }
            return Math.sin(v) > 0 ? 1 * height : -1
          }
        }
      };

      // 生成模拟 3D 饼图的配置项
      function getPie3D(pieData, internalDiameterRatio) {
        const series = []
        let sumValue = 0
        let startValue = 0
        let endValue = 0
        const legendData = []
        const k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3
        // 为每一个饼图数据，生成一个 series-surface 配置
        for (let i = 0; i < pieData.length; i++) {
          sumValue += pieData[i].value

          const seriesItem = {
            name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
            type: 'surface',
            parametric: true,
            wireframe: {
              show: false
            },
            pieData: pieData[i],
            pieStatus: {
              selected: false,
              hovered: false,
              k: k
            }
          }

          if (typeof pieData[i].itemStyle !== 'undefined') {
            const itemStyle = {}

            typeof pieData[i].itemStyle.color !== 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null
            typeof pieData[i].itemStyle.opacity !== 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : null

            seriesItem.itemStyle = itemStyle
          }
          series.push(seriesItem)
        }

        // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
        // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
        for (let i = 0; i < series.length; i++) {
          endValue = startValue + series[i].pieData.value
          series[i].pieData.startRatio = startValue / sumValue
          series[i].pieData.endRatio = endValue / sumValue
          series[i].parametricEquation = getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio, false, false, k, series[i].pieData.value)

          startValue = endValue

          legendData.push(series[i].name)
        }

        // // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
        series.push({
          name: 'mouseoutSeries',
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          itemStyle: {
            opacity: 0.2,
            color: '#3c9bd0'
          },
          parametricEquation: {
            u: {
              min: 0,
              max: Math.PI * 2,
              step: Math.PI / 20
            },
            v: {
              min: 0,
              max: Math.PI,
              step: Math.PI / 20
            },
            x: function (u, v) {
              return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * 2
            },
            y: function (u, v) {
              return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * 2
            },
            z: function (u, v) {
              return Math.cos(v) > 0 ? 1 : -2
            }
          }
        })

        // // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
        series.push({
          name: 'mouseoutSeries',
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          itemStyle: {
            opacity: 0.35,
            color: '#1d67b1'
          },
          parametricEquation: {
            u: {
              min: 0,
              max: Math.PI * 2,
              step: Math.PI / 20
            },
            v: {
              min: 0,
              max: Math.PI,
              step: Math.PI / 20
            },
            x: function (u, v) {
              return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * 2
            },
            y: function (u, v) {
              return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * 2
            },
            z: function (u, v) {
              return Math.cos(v) > 0 ? -13 : -13
            }
          }
        })

        series.push({
          name: 'mouseoutSeries',
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          itemStyle: {
            opacity: 0.15,
            color: '#28f0f7'

          },

          parametricEquation: {
            u: {
              min: 0,
              max: Math.PI * 2,
              step: Math.PI / 20
            },
            v: {
              min: 0,
              max: Math.PI,
              step: Math.PI / 20
            },
            x: function (u, v) {
              return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * 2.3
            },
            y: function (u, v) {
              return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * 2.3
            },
            z: function (u, v) {
              return Math.cos(v) > 0 ? -12 : -12
            }
          }
        })
        return series
      }
      // 传入数据生成 option
      const optionsData = [
        {
          name: '核心专利',
          value: 0,
          itemStyle: {
            color: 'rgba(5,147,146,0.8)'
          }
        },
        {
          name: '重要专利',
          value: 0,
          itemStyle: {
            color: 'rgba(238,117,42,0.8)'
          }
        },
        {
          name: '潜力专利',
          value: 0,
          itemStyle: {
            color: 'rgba(245,165,60,0.8)'
          }
        },
        {
          name: '一般专利',
          value: 0,
          itemStyle: {
            //   opacity: 0.5,
            color: 'rgba(110,193,237,0.8)'
          }
        },
        {
          name: '沉默专利',
          value: 0,
          itemStyle: {
            //   opacity: 0.5,
            color: 'rgba(6,72,157,1)'
          }
        }
      ]
      optionsData.forEach(item => {
        this.rangeList.forEach(ele => {
          if (item.name === ele.name) {
            item.value = ele.count
          }
        })
      })
      // 饼图的高度控制,防止太高
      let boxHeight = 0.3
      const len = String(this.max).length
      if (len > 3) {
        let str = '0.'
        for (let i = 0; i < len - 3; i++) {
          str = str + '0'
        }
        str = str + '2'

        boxHeight = Number(str)
      }
      if (len === 2) {
        boxHeight = 2
      }
      if (len === 1) {
        boxHeight = 10
      }
      const series = getPie3D(optionsData, 0.7, 100, 28, 26, 0.5)
      // 显示线条
      series.push({
        name: 'pie2d',
        type: 'pie',
        label: {
          opacity: 1,
          fontSize: 13,
          lineHeight: 20,
          textStyle: {
            fontSize: 14
          }
        },
        labelLine: {
          lineStyle: {
            width: 2,
            color: 'rgba(255,255,255,.4)'
          },
          length: 20,
          length2: 45
        },
        startAngle: -30, // 起始角度，支持范围[0, 360]。
        clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ['10%', '50%'],

        center: ['50%', '48%'],
        data: optionsData,
        itemStyle: {
          opacity: 0
        }
      })
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      const option = {
        backgroundColor: '',
        animation: true,
        tooltip: {
          formatter: params => {
            if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
              return `${params.seriesName}<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>${option.series[params.seriesIndex].pieData.value}`
            }
          },
          textStyle: {
            fontSize: 14
          }
        },
        title: {

          x: 'center',
          top: '20',
          textStyle: {
            color: '#fff',
            fontSize: 14
          }
        },
        labelLine: {
          show: true,
          showAbove: true,
          lineStyle: {
            color: 'rgba(255,255,255,.4)'
          }
        },
        label: {
          show: true,
          position: 'outside',
          formatter: '{dark|{b}}\n {color|{d}%}',
          rich: {
            dark: {
              color: '#41A6FC'
            },
            color: {
              color: '#fff'
            }
          }
        },
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1
        },
        grid3D: {
          show: false,
          boxHeight: boxHeight, // 显示高度

          viewControl: {
            distance: 170,
            alpha: 25,
            beta: 60,
            rotateSensitivity: 0,
            zoomSensitivity: 1,
            panSensitivity: 0
          }

        },

        series: series
      }
      myChart.setOption(option)
    }
  }
}
</script>
